define 'controller/HeaderLayerController', ['jquery', 'custom/media-query'], ($, mq) ->
  class HeaderLayerController

    constructor: (@$el) ->
      self = this

      if @$el.hasClass('header-icon-group__icon--compte')
        @toggle_element = '.account-navigation-layer'
        @visible_class = 'account-navigation-layer--visible'

      if mq.M_and_up
        @$el.on 'mouseover', (e) ->
          e.preventDefault()
          self._show()

        @$el.on 'mouseleave', (e) ->
          e.preventDefault()
          self._hide()

      else
        $('html').on 'click.headerAccountLayer', (e) =>
          if  @_clickedOpenIcon(e)
            e.preventDefault()
            if !@_isLayerVisible()
              self._show()
            else
              self._hide()
          else
            if @_clickedOutsideLayer
              self._hide()


    _show: ->
      $(@toggle_element).addClass(@visible_class)

    _hide: ->
      $(@toggle_element).removeClass(@visible_class)

    _isLayerVisible: ->
      return $( '.account-navigation-layer' ).hasClass('account-navigation-layer--visible')

    _clickedOpenIcon: (e) ->
      return $(e.target).hasClass('header-icon-group__icon--compte') || $(e.target).hasClass('icon__customer')

    _clickedOutsideLayer: ->
      return ($('.account-navigation-layer' ).has(e.target).length < 1)

    destroy: ->
      @$el.off 'mouseover'
      @$el.off 'mouseleave'
      @$el.off()
      $('html').off 'click.headerAccountLayer'